/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Get_App_DescriptionInputs */



/**
* | output |
* | --- |
* | "Put OpenRift on your phone's home screen" |
*
* @param {Nav_Get_App_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_get_app_description = /** @type {((inputs?: Nav_Get_App_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Get_App_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OpenRift auf den Home-Bildschirm deines Handys legen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter OpenRift à l'écran d'accueil de votre téléphone")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把 OpenRift 添加到手机主屏幕")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把 OpenRift 加入手機主畫面")
	if (locale === "ko") return /** @type {LocalizedString} */ ("휴대폰 홈 화면에 OpenRift 추가")
	return /** @type {LocalizedString} */ ("Put OpenRift on your phone's home screen")
});